import { render, staticRenderFns } from "./myTask.vue?vue&type=template&id=12820258&scoped=true&"
import script from "./myTask.vue?vue&type=script&lang=js&"
export * from "./myTask.vue?vue&type=script&lang=js&"
import style0 from "./myTask.vue?vue&type=style&index=0&id=12820258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12820258",
  null
  
)

export default component.exports